import { render, staticRenderFns } from "./PanelsPage.vue?vue&type=template&id=d6f07cb6&scoped=true"
import script from "./PanelsPage.vue?vue&type=script&lang=js"
export * from "./PanelsPage.vue?vue&type=script&lang=js"
import style0 from "./PanelsPage.vue?vue&type=style&index=0&id=d6f07cb6&prod&lang=scss&scoped=true"
import style1 from "./PanelsPage.vue?vue&type=style&index=1&id=d6f07cb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f07cb6",
  null
  
)

export default component.exports